'use client';

import * as React from 'react';
import toast from 'react-hot-toast';

type ReconnectingOverlayProps = {
  isReconnecting: boolean;
};

export function ReconnectingOverlay({ isReconnecting }: ReconnectingOverlayProps) {
  const [elapsedSec, setElapsedSec] = React.useState(0);
  const prevRef = React.useRef(false);

  React.useEffect(() => {
    if (isReconnecting) {
      setElapsedSec(0);
      prevRef.current = true;
      const id = setInterval(() => setElapsedSec((s) => s + 1), 1_000);
      return () => clearInterval(id);
    }

    if (prevRef.current) {
      toast.success('Conexão restaurada ✓', { duration: 3500, id: 'lk-reconnected' });
    }
    prevRef.current = false;
    setElapsedSec(0);
    return undefined;
  }, [isReconnecting]);

  if (!isReconnecting) return null;

  return (
    <div
      className="meet-reconnecting-overlay"
      role="status"
      aria-live="assertive"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0, 0, 0, 0.72)',
        backdropFilter: 'blur(3px)',
        color: '#fff',
        gap: '16px',
      }}
    >
      <div
        style={{
          width: '48px',
          height: '48px',
          border: '4px solid rgba(255,255,255,0.2)',
          borderTopColor: '#fff',
          borderRadius: '50%',
          animation: 'lk-spin 0.8s linear infinite',
        }}
      />
      <p style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>
        Reconectando à reunião…
      </p>
      {elapsedSec > 0 && (
        <p style={{ margin: 0, fontSize: '13px', opacity: 0.7 }}>
          {elapsedSec}s — não feche esta aba
        </p>
      )}
      <p style={{ margin: 0, fontSize: '12px', opacity: 0.5, maxWidth: '280px', textAlign: 'center' }}>
        A reunião continua para os outros participantes.
      </p>
      <style>{`
        @keyframes lk-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
